export const EMPTY = '—';

export const formatDeviceDate = (value) => {
  if (!value) return EMPTY;
  return new Date(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDeviceDateTime = (value) => {
  if (!value) return EMPTY;
  return new Date(value).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const fieldChanged = (prev, curr, field) => (prev?.[field] ?? null) !== (curr?.[field] ?? null);

export const extractHardwareChanges = (history = []) => {
  const changes = [];
  for (let i = 1; i < history.length; i += 1) {
    const from = history[i - 1];
    const to = history[i];
    if (fieldChanged(from, to, 'hardware_id')) {
      changes.push({ key: `${from.hardware_id || 'none'}-${to.hardware_id || 'none'}-${to.created_at}`, from, to });
    }
  }
  return changes.reverse();
};

export const extractSoftwareChanges = (history = []) => {
  const changes = [];
  for (let i = 1; i < history.length; i += 1) {
    const from = history[i - 1];
    const to = history[i];
    const displayChanged = fieldChanged(from, to, 'display_software_id');
    const deviceChanged = fieldChanged(from, to, 'device_software_id');
    if (displayChanged || deviceChanged) {
      changes.push({ key: `${to.created_at}-${i}`, from, to, displayChanged, deviceChanged });
    }
  }
  return changes.reverse();
};

export const getHistoryChangeLabels = (current, previous) => {
  if (!previous) return 'Initial Assignment';
  const labels = [];
  if (fieldChanged(previous, current, 'partner_id')) labels.push('Partner');
  if (fieldChanged(previous, current, 'field_officer_id')) labels.push('Field Officer');
  if (fieldChanged(previous, current, 'hardware_id')) labels.push('Hardware');
  if (fieldChanged(previous, current, 'display_software_id')) labels.push('Display SW');
  if (fieldChanged(previous, current, 'device_software_id')) labels.push('Firmware');
  if (fieldChanged(previous, current, 'warranty_end_date')) labels.push('Warranty');
  return labels.length > 0 ? labels.join(', ') : 'No Change';
};

/** Keep only IDs present in dropdown API results — prevents stale/mismatched values */
export const pickDropdownId = (options, currentId) => {
  if (!currentId || !Array.isArray(options)) return '';
  return options.some((o) => String(o.id) === String(currentId)) ? String(currentId) : '';
};

export const pickPartnerFieldOfficerId = (officers, currentId) => {
  if (!currentId || !Array.isArray(officers)) return '';
  return officers.some((o) => String(o.field_officer_id) === String(currentId))
    ? String(currentId)
    : '';
};
